import { z } from 'zod';

/**
 * Purchase Order submission form validation schema
 */
export const purchaseOrderFormSchema = z.object({
  supplier_name: z
    .string()
    .trim()
    .default(''),

  title: z
    .string()
    .trim()
    .min(1, 'Order title is required'),

  description: z
    .string()
    .optional(),

  eta_date: z
    .string()
    .optional(),
});

export type PurchaseOrderFormData = z.infer<typeof purchaseOrderFormSchema>;

/**
 * Validation helper for order quantities
 * Separate from main form as it's managed independently
 */
export function validateOrderQuantities(quantities: Record<string, number>): boolean {
  const totalItems = Object.values(quantities).reduce((sum, qty) => sum + qty, 0);
  return totalItems > 0;
}
